module.exports = __webpack_public_path__ + "static/img/building-skeleton.cfdbf15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/building-skeleton.png
// module id = 323
// module chunks = 64